<template>
  <div class="animated fadeIn">
    <b-card >
      <div slot="header">Workflow Action History
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="12">
          <b-input-group >
              <b-input-group-prepend><span class="p-2">Date Range</span></b-input-group-prepend>
              <b-form-input v-model="filter.tgl1" type="date" :state="!$v.filter.tgl1.$error"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
              <b-input-group-prepend><span class="p-2">Workflow Name</span></b-input-group-prepend>
              <b-form-select  v-model="filter.wftypekey" :options="workflowtypes"  :plain="true" ></b-form-select>
              <b-input-group-prepend><span class="p-2">Document No.</span></b-input-group-prepend>
              <b-form-input v-model="filter.nomor" ></b-form-input>
              <b-input-group-append>
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Open</b-button>
              </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filtertxt"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filtertxt" @click="filtertxt=''">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="workflow">Workflow Name</b-form-checkbox>
                      <b-form-checkbox value="detail_doc">Document No.</b-form-checkbox>
                      <b-form-checkbox value="creatorName">Creator Name</b-form-checkbox>
                      <b-form-checkbox value="actiontake">Action Take</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template>
        <b-table
          class="mb-0"
          ref="table"
          outlined  responsive hover small
          style="font-size:smaller;" 
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :per-page="tblData.limit"
            :filter="filtertxt"
            @filtered="onFiltered"                

        >
          <template v-slot:cell(createdon)="data">
            {{ data.item.createdon |  moment("ddd, DD-MMM-YYYY hh:mm:ss") }}
          </template>
          <template v-slot:cell(assign_start)="data">
            {{ data.item.assign_start |  moment("ddd, DD-MMM-YYYY hh:mm:ss") }}
          </template>
          <template v-slot:cell(assign_action)="data">
            {{ data.item.assign_action |  moment("ddd, DD-MMM-YYYY hh:mm:ss") }}
          </template>
          <template v-slot:cell(approver_seq)="data">
            {{ data.item.approver_seq }}
            <p v-if="data.item.ownertotal>1">{{ data.item.ownerlist }}</p>            
          </template>
          
          <template v-slot:cell(actiontake)="data">
            <span v-if="data.item.actiontake=='EXPIRED'" style="background-color:red;">           
                  {{data.item.actiontake}}</span>
            <span v-else> 
                  {{data.item.actiontake}}</span>
          </template>
          <template v-slot:cell(pending_time)="data">
              {{(data.item.pending_time)|numFormat}}"
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="5">
            <div class="ml-1">
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries,   <span class="mr-1">limit per page :</span> 
            <input type="number" style="width:80px;" v-model="limit"/>
            </div>
          </b-col>
          <b-col cols="2">            
            <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
              <b> {{ filterShow }}</b>  Filter
            </b-form-checkbox>
          </b-col>
          <b-col cols="5" style="text-align:right;">            
            <b-pagination  class="ml-1" 
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>      
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import wfname from "../../apis/wffunctionalapproval";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      isLoading: false,
      showList:true,
      showForm:false,
      filter:{wftypekey: '', nomor:'', tgl1:'', tgl2:''},
      filtertxt:null,
      filterOn: [], 
      filterShow:'Show',
      tblData: {
        page: 1,
        limit: 50,
        total: 0,
        items: [],
      },
      limit:50,

    tblFields:[
          {
            key: "workflow",
            label: "Workflow/Approval Name",
          },
          {
            key: "createdon",
            label: "Created On",
          },
          {
            key: "creatorName",
            label: "Created By",
            thClass: "text-center",
          },
          {
            key: "iscompleted",
            label: "Completed",
            thClass: "text-center",
          },
          {
            key: "detail_doc",
            label: "Document",
          }  ,        
          {
            key: "approver",
            label: "Approver",
            thClass: "text-center",
          },
          {
            key: "approver_seq",
            label: "Seq. Approver",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:40px",
          },
          {
            key: "assign_start",
            label: "Assignment Start",
          },
          {
            key: "actiontake",
            label: "Action Take",
            thClass: "text-center",
          },
          {
            key: "message",
            label: "Comment",
          },
          {
            key: "assign_action",
            label: "Assignment Action@",
          },
          {
            key: "pending_time",
            label: "Pending Time",
            thClass: "text-right",
            sortable: true
          },
        ],
      workflowtypes:[{value:'', text:'--ALL--'}]
    };
  },
components: {Loading },  
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },       

  },  

  created: async function() {
    const wfs = await wfname.workflowtype();
    this.workflowtypes = this.workflowtypes.concat(wfs);
  },
  methods: {
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY-MM') + '-01', 'YYYY-MM-DD');
        if (!(this.filter.tgl1)) {
          this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },    
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const data = await wfname.actionhist(this.filter);
                this.tblData.items= data.list;
                this.tblData.total=this.tblData.items.length;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                await wfname.actionhistexport(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.wftypekey= '';
        this.tblData.nomor= '';
    },

    close(){
      router.push("home");
    },    
  }
};
</script>
